/**
 * ProgressWidget — Niveau, XP et streak
 */
import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Flame, Zap } from 'lucide-react';

export const ProgressWidget = memo(function ProgressWidget({
  level, levelProgress, todayXP, currentStreak,
}) {
  return (
    <div
      className="flex-1 px-3 py-3 rounded-2xl flex flex-col gap-2.5"
      style={{ background: 'rgba(255,255,255,0.025)', border: '1px solid rgba(255,255,255,0.06)' }}
      role="region"
      aria-label="Progression"
    >
      {/* Niveau + XP */}
      <div className="flex items-center justify-between">
        <span className="text-xs font-semibold" style={{ color: 'rgba(255,255,255,0.45)' }}>
          Niveau <span style={{ color: '#fbbf24' }}>{level}</span>
        </span>
        <div className="flex items-center gap-1">
          <Zap className="w-3 h-3" style={{ color: '#fbbf24' }} />
          <span className="text-[11px] font-bold" style={{ color: '#fbbf24' }}>+{todayXP} XP</span>
        </div>
      </div>

      {/* Barre XP */}
      <div className="h-1.5 rounded-full overflow-hidden" style={{ background: 'rgba(255,255,255,0.05)' }}>
        <motion.div
          className="h-full rounded-full relative overflow-hidden"
          style={{ background: 'linear-gradient(90deg, #f59e0b, #f97316)' }}
          animate={{ width: `${levelProgress || 0}%` }}
          transition={{ duration: 0.7, ease: 'easeOut' }}
        >
          <div className="absolute inset-0"
            style={{ background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.18) 50%, transparent)', animation: 'shimmer 2s infinite' }} />
        </motion.div>
      </div>

      {/* Streak */}
      {currentStreak > 0 ? (
        <div className="flex items-center gap-1.5">
          <Flame className="w-3.5 h-3.5" style={{ color: '#fb923c' }} />
          <span className="text-xs font-bold" style={{ color: '#fb923c' }}>{currentStreak}</span>
          <span className="text-[10px]" style={{ color: 'rgba(255,255,255,0.25)' }}>jours</span>
        </div>
      ) : (
        <div className="flex items-center gap-1.5">
          <Flame className="w-3.5 h-3.5" style={{ color: 'rgba(255,255,255,0.12)' }} />
          <span className="text-[10px]" style={{ color: 'rgba(255,255,255,0.18)' }}>Commence ton streak</span>
        </div>
      )}
    </div>
  );
});

export default ProgressWidget;
